import { Component } from 'react';
import DOMPurify from 'dompurify';
import { apiGetTextP } from '../../GanjiTools';

class ServerSide extends Component {
    state = {
        markup: '<div>No url</div>',
    }

    componentDidMount() {
        if (!(this.props.url?.length > 0))
            return;

        apiGetTextP(this.props.url)
            .then(res => this.state.markup = res)
            .catch(err => this.state.markup = `<div>Could not fetch ServerSide markup from url ${this.props.url} ==> ${err}</div>`)
            .finally(() => this.forceUpdate());
    }

    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.state.markup, { USE_PROFILES: { html: true } }) }}
            >
            </div>
        );
    }
}

export default ServerSide;